import {Controller} from '@hotwired/stimulus'

// The sidebar HubSpot chat toggle (GF-2954). Mirrors the React FreshChat
// component: no-op on a restricted plan (the premium callout renders instead),
// toggle the HubSpot widget when it loaded, alert about ad-blockers otherwise.
export default class extends Controller {
  static values = {restricted: Boolean}

  connect() {
    this.chatOpen = false
  }

  toggle() {
    if (this.restrictedValue)
      return

    if (window.HubSpotConversations) {
      if (this.chatOpen) {
        window.HubSpotConversations.widget.close()
        this.chatOpen = false
      } else {
        window.HubSpotConversations.widget.open()
        this.chatOpen = true
      }
    } else {
      // eslint-disable-next-line no-alert
      alert(this.element.getAttribute('data-adblock-message'))
    }
  }
}
